import axios from 'axios';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:4001/api';
const api  = axios.create({ baseURL: BASE });

export const getLabs       = ()          => api.get('/labs');
export const updateLab     = (id, data)  => api.put(`/labs/${id}`, data);
export const deleteLab     = (id)        => api.delete(`/labs/${id}`);
export const getOverview   = (labId)     => api.get('/reports/overview',    { params: { lab_id: labId } });
export const getLowStock   = (labId)     => api.get('/reports/low-stock',   { params: { lab_id: labId } });
export const getExpiring   = (days, labId) => api.get('/reports/expiring',  { params: { days, lab_id: labId } });
export const getReorder    = (labId)     => api.get('/reports/reorder',     { params: { lab_id: labId } });
export const getItems      = (p)         => api.get('/items',               { params: p });
export const getItem       = (id)        => api.get(`/items/${id}`);
export const updateItem    = (id, d)     => api.put(`/items/${id}`, d);
export const getAudits     = (p)         => api.get('/audits',              { params: p });
export const getAudit      = (id)        => api.get(`/audits/${id}`);
export const getSections   = (labId)     => api.get('/sections',            { params: { lab_id: labId } });
export const getRecipients = ()          => api.get('/alerts/recipients');
export const addRecipient  = (d)         => api.post('/alerts/recipients', d);
export const deleteRecipient = (id)      => api.delete(`/alerts/recipients/${id}`);
export const getAlertLog   = ()          => api.get('/alerts/log');
export const triggerAlerts = ()          => api.post('/alerts/check');
export const getTrend      = (id)        => api.get(`/reports/trend/${id}`);
export const getAuditSummary = (limit, labId) => api.get('/reports/audit-summary', { params: { limit, lab_id: labId } });

export default api;
